import { render, staticRenderFns } from "./CompanyVisionPage.vue?vue&type=template&id=c0052606&scoped=true&"
import script from "./CompanyVisionPage.vue?vue&type=script&lang=js&"
export * from "./CompanyVisionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0052606",
  null
  
)

export default component.exports